<template>
  <v-autocomplete
    v-model="city"
    :items="entries"
    :loading="isLoading"
    :search-input.sync="search"
    color="white"
    hide-no-data
    hide-selected
    item-text="properties.full_address"
    item-value="id"
    :placeholder="$t('cities.search')"
    return-object
    no-filter
    @change="changed"
  ></v-autocomplete>
</template>

<script>
import mbApi from "@/APIS/mapbox-api";
import _ from "lodash";

export default {
  name: "CitiesAutocomplete",
  data: () => ({
    entries: [],
    isLoading: false,
    city: null,
    search: null,
  }),

  computed: {
    items() {
      return this.entries;
    },
  },
  methods: {
    changed(val) {
      this.$emit("selected-city", val);
    },
    clearTextfield() {
      this.city = null;
    },
    // eslint-disable-next-line func-names
    findCities: _.debounce(function () {
      if (this.isLoading) return;
      this.isLoading = true;

      mbApi
        .cityAutocomplete(this.search)
        .then((results) => {
          this.entries = results;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.isLoading = false;
        });
    }, 400),
  },

  watch: {
    search(val) {
      if (val && val.length > 0) {
        this.findCities();
      }
    },
  },
};
</script>
